import Api from '../http.service';
/**
 * update department
 * @param {Object} payload
 * @param {object} payload.data
 * @param {String} payload.data.name
 * @param {String} payload.data.code
 * @param {String} payload.data.profileId
 */
export const insert = (payload) =>
  Api.POST({ url: 'profile_department', data: payload.data });

/**
 * update department
 * @param {Object} payload
 * @param {object} payload.data
 * @param {String} payload.data.id
 * @param {String} payload.data.name
 * @param {String} payload.data.code
 * @param {String} payload.data.profileId
 */
export const update = (payload) =>
  Api.PUT({ url: 'profile_department', data: payload.data });

/**
 * remove department
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {String} payload.data.id
 */
export const remove = (payload) =>
  Api.DELETE({ url: 'profile_department', data: payload.data });

/**
 * get by Id department
 * @param {Object} payload
 * @param {String} payload.id
 */
export const getById = (id) => Api.GET({ url: `profile_department/id/${id}` });

/**
 * get all department
 * @param {Object} payload
 * @param {String} payload.profileId
 * @param {String} payload.pageNumber
 * @param {String} payload.itemPerPage
 */
export const getAllByProfileId = (payload) =>
  Api.GET({
    url: `profile_department/profile_all/${payload.profileId}/${
      payload.pageNumber - 1
    }/${payload.itemPerPage}`,
  });
